import http from './http';

export function fetchHello() {
  return http.get('/hello');
}
